import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import SocieteAndUserService from "../../../services/societeAndUser";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#007bb2",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },

    large: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
  },
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const AllAdminsAccount = () => {
  const navigate = useNavigate();

  const [allSuppliers, setAllSuppliers] = useState([]);
  const [allSuppliersDeleted, setAllSuppliersDeleted] = useState([]);

  const [allSuppliersPictures, setAllSuppliersPictures] = useState([]);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const myRefs = useRef([]);
  const myRefsDeleted = useRef([]);
  const myRefsTwo = useRef([]);
  const myRefsTwoDeleted = useRef([]);
  const refAvailableButton = useRef([]);
  const classes = useStyles();

  useEffect(() => {
    allSuppliers &&
      allSuppliers.map((element, index2) => {
        uploadAndDownloadService
          .downloadFile(element.fileUrl)
          .then((response) => {
            let index = element.fileUrl.lastIndexOf(".");
            let extension = element.fileUrl.substr(index + 1);

            let base64ImageString = Buffer.from(
              response.data,
              "binary"
            ).toString("base64");

            let image = "data:image/png;base64," + base64ImageString;

            myRefs.current[index2].src = image;
          })
          .catch(() => {});
      });
  }, [allSuppliers]);

  useEffect(() => {
    allSuppliersDeleted &&
      allSuppliersDeleted.map((element, index2) => {
        uploadAndDownloadService
          .downloadFile(element.fileUrl)
          .then((response) => {
            let index = element.fileUrl.lastIndexOf(".");
            let extension = element.fileUrl.substr(index + 1);

            let base64ImageString = Buffer.from(
              response.data,
              "binary"
            ).toString("base64");

            let image = "data:image/png;base64," + base64ImageString;

            myRefsDeleted.current[index2].src = image;
          })
          .catch(() => {});
      });
  }, [allSuppliersDeleted]);

  useEffect(() => {
    let isDeleted = [0, 1];

    isDeleted.forEach((elementTwo) => {
      SocieteAndUserService.getAllIwareClient(elementTwo)
        .then((response) => {
          if (Object.keys(response.data)[0] == "userResponse") {
            if (elementTwo == 0) {
              setAllSuppliers(response.data.userResponse);
            } else if (elementTwo == 1) {
              setAllSuppliersDeleted(response.data.userResponse);
            }
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    });
  }, []);

  const onAddSocieteHandler = () => {
    navigate(`/addAdminAccount`);
  };

  const onDeleteOrRestaureSociete = (
    isDeleted,
    idUserToDelete,
    index,
    state
  ) => {
    SocieteAndUserService.deleteAndRestoreClientPartner(
      idUserToDelete,
      isDeleted
    )
      .then((response) => {
        if (Object.keys(response.data)[0] == "success") {
          window.location.href = "/allAdminsAccount";
        } else if (Object.keys(response.data)[0] == "error") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });

    console.log("index", index);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les clients </h5>

                  <a
                    href="#"
                    class="btn btn-success  float-right   "
                    onClick={onAddSocieteHandler}
                  >
                    <i class="fas fa-plus"></i>
                    Ajouter
                  </a>
                </div>
              </div>
              <section class="content">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title"> </h3>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <TableContainer component={Paper}>
                      <Table
                        className={classes.table}
                        aria-label="simple table"
                      >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Image</StyledTableCell>
                            <StyledTableCell style={{ textAlign: "center" }}>
                              Nom
                            </StyledTableCell>
                            <StyledTableCell style={{ textAlign: "center" }}>
                              Prénom
                            </StyledTableCell>
                            <StyledTableCell style={{ textAlign: "center" }}>
                              Email
                            </StyledTableCell>

                            <StyledTableCell style={{ textAlign: "center" }}>
                              Télephone
                            </StyledTableCell>
                            <StyledTableCell style={{ textAlign: "center" }}>
                              CIN
                            </StyledTableCell>

                            <StyledTableCell style={{ textAlign: "center" }}>
                              Date de création
                            </StyledTableCell>

                            <StyledTableCell style={{ textAlign: "center" }}>
                              Disponibilité
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {allSuppliers &&
                            allSuppliers.map((row, index) => (
                              <StyledTableRow key={row.id}>
                                <StyledTableCell component="th" scope="row">
                                  <img
                                    alt="Remy Sharp"
                                    src={allSuppliersPictures[0]}
                                    ref={(ref) => {
                                      myRefs.current[index] = ref;
                                    }}
                                    class="rounded-circle"
                                    style={{ width: "50px", height: "50px" }}
                                  ></img>
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  {row.name}
                                </StyledTableCell>
                                <StyledTableCell>{row.prenom}</StyledTableCell>
                                <StyledTableCell>{row.email}</StyledTableCell>
                                <StyledTableCell>
                                  {row.phoneNumber}
                                </StyledTableCell>

                                <StyledTableCell>{row.cin}</StyledTableCell>

                                <StyledTableCell>
                                  {row.creationData.replaceAll("-", "/")}
                                </StyledTableCell>

                                {row.isDeleted == 0 ? (
                                  <StyledTableCell>
                                    <button
                                      onClick={() =>
                                        onDeleteOrRestaureSociete(
                                          row.isDeleted,
                                          row.id,
                                          index,
                                          "allSuplliers"
                                        )
                                      }
                                      type="button"
                                      class="btn btn-danger"
                                    >
                                      Archiver
                                    </button>
                                  </StyledTableCell>
                                ) : (
                                  <StyledTableCell>
                                    <button
                                      onClick={() =>
                                        onDeleteOrRestaureSociete(
                                          row.isDeleted,
                                          row.id,
                                          index,
                                          "allSuplliers"
                                        )
                                      }
                                      type="button"
                                      class="btn btn-primary"
                                    >
                                      Restaurer
                                    </button>
                                  </StyledTableCell>
                                )}
                              </StyledTableRow>
                            ))}

                          {allSuppliersDeleted &&
                            allSuppliersDeleted.map((row, index) => (
                              <StyledTableRow key={row.id}>
                                <StyledTableCell component="th" scope="row">
                                  <img
                                    alt="Remy Sharp"
                                    src={allSuppliersPictures[0]}
                                    ref={(refD) => {
                                      myRefsDeleted.current[index] = refD;
                                    }}
                                    class="rounded-circle"
                                    style={{ width: "50px", height: "50px" }}
                                  ></img>
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  {row.name}
                                </StyledTableCell>
                                <StyledTableCell>{row.prenom}</StyledTableCell>
                                <StyledTableCell>{row.email}</StyledTableCell>
                                <StyledTableCell>
                                  {row.phoneNumber}
                                </StyledTableCell>

                                <StyledTableCell>{row.cin}</StyledTableCell>

                                <StyledTableCell>
                                  {row.creationData.replaceAll("-", "/")}
                                </StyledTableCell>
                                {row.isDeleted == 0 ? (
                                  <StyledTableCell>
                                    <button
                                      onClick={() =>
                                        onDeleteOrRestaureSociete(
                                          row.isDeleted,
                                          row.id,
                                          index,
                                          "deletedSupplier"
                                        )
                                      }
                                      type="button"
                                      class="btn btn-danger"
                                    >
                                      Archiver
                                    </button>
                                  </StyledTableCell>
                                ) : (
                                  <StyledTableCell>
                                    <button
                                      onClick={() =>
                                        onDeleteOrRestaureSociete(
                                          row.isDeleted,
                                          row.id,
                                          index,
                                          "deletedSupplier"
                                        )
                                      }
                                      type="button"
                                      class="btn btn-primary"
                                    >
                                      Restaurer
                                    </button>
                                  </StyledTableCell>
                                )}
                              </StyledTableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </section>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AllAdminsAccount;
